import React from 'react';
import '../../less';
import '../../less/mobile.less';
import {Link, Button, Control} from 'MWC';
import AppleSetupCard from '../../views/google-setup-card.c';
import PaymentNotice from '../../views/payment-notice.c';
import AdditionCard from '../../../AdditionCard/views/addition-card.c';
import Breadcrumbs from '../../../../../../auxiliary-components/Breadcrumbs';
import {MAIN, GOOGLE_PAY, SERVICES} from '../../../../../../auxiliary-components/Breadcrumbs/collection/breadcrumbs.config';

export default function template() {
    const links = [MAIN, SERVICES, GOOGLE_PAY];

    return (
        <div className="module-google_pay-container">
            <Breadcrumbs links={links} {...this.props} />
            <div className="banner">
                <div className="content">
                    <div className="left-cell">
                        <div className="banner-title">{this.l10n('GOOGLE_PAY_HEAD_TEXT')}</div>
                        <div className="banner-desc">{this.l10n('GOOGLE_PAY_HEAD_DESC')}</div>
                        <Link
                            href={`/services`}
                            onClick={e => this.context.app.navigate(`/services`, e)}
                        >
                            <div className="backward-btn">{this.l10n('BREADCRUMBS_SERVICES')}</div>
                        </Link>
                    </div>
                </div>
            </div>

            <div className="module-content-wrapper">
                <p className="main-title">{this.l10n('GOOGLE_PAY_SLOGAN_TITLE')} Pay!<span className="pay-b"></span></p>
                <p className="main-desc">{this.l10n('GOOGLE_PAY_SLOGAN_DESC')}</p>
            </div>

            <div className="module-content-wrapper">
                <AppleSetupCard {...this.props} />
            </div>

            <PaymentNotice {...this.props} />
          <div className="module-content-wrapper">
            <AdditionCard {...this.props} />
          </div>
        </div>
    );
}
